<template>
  <!-- prettier-ignore -->
  <router-link
    :class="{ 'selected': selected }"
    :data-category-id="category.id"
    :to="to">
    <div :class="classes">
      <div class="category__title">
        <span v-html="$t(content).title" />
        <ovp-icon
          v-if="category.disabled"
          art="light"
          name="circle-question"
        />
        <template v-if="info">
          &nbsp;
          <ovp-icon
            v-if="info"
            v-tooltip="info"
            art="light"
            class="info"
            name="circle-info"
          />
        </template>
      </div>

      <div class="category__price">
        <ovp-price
          :prefix="$t('product.asof')"
          :price="category.price"
          :suffix="$t('product.currency')"
        />
        <template v-if="category.id === 'KVG'">*</template>
      </div>

      <div class="category__description">
        {{ $t(content).description }}
      </div>

      <div class="category__action">
        <template v-if="hasChildren">
          <a
            v-tooltip="info"
            html-tooltip
            v-text="$t('product.toOffer')"
          />
        </template>

        <template v-else>
          <ovp-icon
            v-tooltip="info"
            art="light"
            class="info"
            name="circle-info"
          />
        </template>
      </div>
    </div>
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex'

import OvpPrice from '@/components/Product/Price'

export default {
  name: 'Category',

  components: {
    OvpPrice,
  },

  props: {
    category: {
      type: Object,
      required: true,
    },

    collapsed: {
      type: Boolean,
      default: false,
    },

    personId: {
      type: String,
      required: true,
    },

    selected: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters('basket', ['getGroupsFromCategory']),

    classes() {
      return {
        category: true,
        'category--unavailable': !this.category.available,
        'category--collapsed': this.collapsed,
        'category--selected': this.selected,
      }
    },

    content() {
      return `content.categories.${this.category.id}`
    },

    hasChildren() {
      return this.getGroupsFromCategory(this.personId, this.category.id).length > 0
    },

    info() {
      return (
        this.category.messages
          .map(m => {
            return this.$t(`error.${m.key}`)
          })
          .join('; ')
          .trim() || false
      )
    },

    to() {
      if (!this.hasChildren) {
        return ''
      } else if (this.collapsed && this.selected) {
        return `/products/${this.personId}`
      } else {
        return `/products/${this.personId}/${this.category.id}`
      }
    },
  },
}
</script>

<style name="mobile" scoped>
.category {
  display: grid;
  gap: 8px;
  color: var(--c-black);
  padding: 24px 16px 16px 16px;
  border: 1px solid var(--c-black);
  grid-template-rows: 24px 28px minmax(60px, auto) 20px;
  height: 100%;
  transition: all 0.25s ease-in-out;
  overflow: hidden;

  .category {
    &__title {
      font-size: 15px;
      line-height: 24px;

      .info {
        display: none;
      }
    }

    &__price {
      font-size: 22px;
      line-height: 28px;
      font-weight: normal;

      .price {
        margin: 0 5px 0 0;
      }
    }

    &__description {
      font-size: 14px;
      line-height: 20px;
      font-weight: normal;
    }

    &__action {
      text-align: right;
    }
  }

  &--collapsed {
    height: 72px;
    grid-template-rows: 72px;

    .category {
      &__title {
        text-align: center;
        white-space: nowrap;
        font-weight: normal;

        .info {
          display: initial;
        }
      }

      &__price,
      &__description,
      &__action {
        display: none;
      }
    }
  }

  &--selected {
    background-color: var(--c-original-green);
    border-color: var(--c-original-green);

    .category__title {
      color: var(--c-white);
      font-weight: bold;
    }
  }

  &--unavailable {
    border: transparent;
    cursor: default;

    .category {
      &__title span,
      &__price,
      &__description {
        opacity: 0.25;
      }
    }
  }

  &--disabled {
    cursor: default;
    opacity: 0.6;
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
}
</style>
